import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DocumentTypeInternalRevenueBulletins } from './documenttypeinternalrevenuebulletins';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { DocumenttypeinternalrevenuebulletinsService } from './documenttypeinternalrevenuebulletins.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

declare var $: any;
@Component({
  selector: 'app-documenttypeinternalrevenuebulletins',
  templateUrl: './documenttypeinternalrevenuebulletins.component.html',
  styleUrls: ['./documenttypeinternalrevenuebulletins.component.css']
})
export class DocumenttypeinternalrevenuebulletinsComponent implements OnInit {

  sendMenuId: number;
  sendPageName: string = 'DocumentTypeInternalRevenueBulletins';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
  documenttypeinternalrevenuebulletinsForm: FormGroup;
  documenttypeinternalrevenuebulletinss: DocumentTypeInternalRevenueBulletins[] = [];
  documenttypeinternalrevenuebulletinssactive: DocumentTypeInternalRevenueBulletins[] = [];
  documenttypeinternalrevenuebulletins: DocumentTypeInternalRevenueBulletins;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  documenttypeinternalrevenuebulletinsModalRef: BsModalRef;
  operation: string;
  userid: number;
  documenttypeinternalrevenuebulletinsid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'documenttypeinternalrevenuebulletins'; //set default
  reverse: boolean = false;

  constructor(
    private documenttypeinternalrevenuebulletinsservice: DocumenttypeinternalrevenuebulletinsService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      // console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('DocumentTypeInternalRevenueBulletins_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('DocumentTypeInternalRevenueBulletins_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('DocumentTypeInternalRevenueBulletins_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('DocumentTypeInternalRevenueBulletins_action');
    }
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.documenttypeinternalrevenuebulletinsForm = this.formBuilder.group({
      documenttypeinternalrevenuebulletinsid: [''],
      documenttypeinternalrevenuebulletins: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  getactiveinactive(showallp) {
    this.documenttypeinternalrevenuebulletinssactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.documenttypeinternalrevenuebulletinss.forEach(data => {
        if (data.active == 1) {
          this.documenttypeinternalrevenuebulletinssactive.push(data);
        }
      });
      this.documenttypeinternalrevenuebulletinss = [];
      this.documenttypeinternalrevenuebulletinss = this.documenttypeinternalrevenuebulletinssactive;
    }
    else {
      this.showall = true;
      this.documenttypeinternalrevenuebulletinss = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedRevenueBulletins");
    let data = arrays.find(ob => ob['name'] === 'Document Type Internal Revenue Bulletins');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedRevenueBulletins","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedRevenueBulletins",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.documenttypeinternalrevenuebulletinsModalRef.hide();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.documenttypeinternalrevenuebulletinss = [];
    this.documenttypeinternalrevenuebulletinssactive = [];
    this.documenttypeinternalrevenuebulletinsservice.Get().subscribe(res => {
      this.documenttypeinternalrevenuebulletinss = res;
      if (this.showallstatus == true) {
        this.documenttypeinternalrevenuebulletinss.forEach(data => {
          if (data.active == 1) {
            this.documenttypeinternalrevenuebulletinssactive.push(data);
          }
        });
        this.documenttypeinternalrevenuebulletinss = [];
        this.documenttypeinternalrevenuebulletinss = this.documenttypeinternalrevenuebulletinssactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  get g() { return this.documenttypeinternalrevenuebulletinsForm.controls; }

  Post(documenttypeinternalrevenuebulletins: DocumentTypeInternalRevenueBulletins) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.documenttypeinternalrevenuebulletinsForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.documenttypeinternalrevenuebulletinsForm.errors);
    //}

    if ((documenttypeinternalrevenuebulletins.documenttypeinternalrevenuebulletins.trim() == undefined) || (documenttypeinternalrevenuebulletins.documenttypeinternalrevenuebulletins.trim() == '')) {
      this.toastr.error('DocumentTypeInternalRevenueBulletins should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    documenttypeinternalrevenuebulletins.documenttypeinternalrevenuebulletins = documenttypeinternalrevenuebulletins.documenttypeinternalrevenuebulletins.trim();
    if (this.operation == 'add') {

      documenttypeinternalrevenuebulletins.createdby = this.userid;
      msg = "Record Added Successfully";
      this.documenttypeinternalrevenuebulletinsservice.Post(documenttypeinternalrevenuebulletins).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.documenttypeinternalrevenuebulletinsModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      documenttypeinternalrevenuebulletins.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.documenttypeinternalrevenuebulletinsservice.Put(documenttypeinternalrevenuebulletins).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.documenttypeinternalrevenuebulletinsModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.documenttypeinternalrevenuebulletinsForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.documenttypeinternalrevenuebulletinsForm.value.active = 1;
    } else {
      this.documenttypeinternalrevenuebulletinsForm.value.active = 0
    }
  }

  OpenConfirmTemplate(documenttypeinternalrevenuebulletins, template: TemplateRef<any>) {
    if (documenttypeinternalrevenuebulletins.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.documenttypeinternalrevenuebulletins = documenttypeinternalrevenuebulletins;

          this.Delete();

        }

      });

  }

  Delete() {
    var msg;
    if (this.documenttypeinternalrevenuebulletins.active == 0) {
      this.documenttypeinternalrevenuebulletins.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.documenttypeinternalrevenuebulletins.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.documenttypeinternalrevenuebulletins.modifiedby = this.userid;
    this.documenttypeinternalrevenuebulletinsservice.Delete(this.documenttypeinternalrevenuebulletins).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.documenttypeinternalrevenuebulletinsModalRef.hide();
  }

  openDocumentTypeInternalRevenueBulletinsModal(template: TemplateRef<any>, type, documenttypeinternalrevenuebulletins?: DocumentTypeInternalRevenueBulletins) {

    this.operation = type

    if (type == 'update') {
      this.documenttypeinternalrevenuebulletinsForm.controls['documenttypeinternalrevenuebulletinsid'].setValue(documenttypeinternalrevenuebulletins.documenttypeinternalrevenuebulletinsid);
      this.documenttypeinternalrevenuebulletinsForm.controls['documenttypeinternalrevenuebulletins'].setValue(documenttypeinternalrevenuebulletins.documenttypeinternalrevenuebulletins);
      this.documenttypeinternalrevenuebulletinsForm.controls['active'].setValue(documenttypeinternalrevenuebulletins.active);
      this.documenttypeinternalrevenuebulletins = documenttypeinternalrevenuebulletins;
    }
    if (type == 'add') {
      this.documenttypeinternalrevenuebulletinsForm.controls['documenttypeinternalrevenuebulletinsid'].setValue(0);
      this.documenttypeinternalrevenuebulletinsForm.controls['documenttypeinternalrevenuebulletins'].setValue('');
      this.documenttypeinternalrevenuebulletinsForm.controls['active'].setValue(1);
    }
    this.documenttypeinternalrevenuebulletinsModalRef = this.modalService.show(template, this.config);

    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }

}
